import { defineStore } from 'pinia'

export default defineStore({
  id: 'taskDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isTaskArchive: false
    }
  },
  actions: {
    setColumnTaskState: function (payload: any) {
      this.columnState = payload
    },
    setIsTaskArchive: function (payload: any) {
      this.isTaskArchive = payload
    }
  },
  getters: {
    getColumnTaskState: (state: any) => state.columnState,
    getIsTaskArchive: (state: any) => state.isTaskArchive
  }
})
